import { render } from "./OptionActionDataTable.vue?vue&type=template&id=2b3c0f8c"
import script from "./OptionActionDataTable.vue?vue&type=script&lang=js"
export * from "./OptionActionDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__